export default __webpack_public_path__ + "370f5da0bb6a1cfbb80a26177df06adb.jpg";